function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Stopped",
  strokeDasharray: "none",
  strokeOpacity: 1,
  fill: "none",
  stroke: "none",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("title", null, "Stopped"), /*#__PURE__*/React.createElement("g", {
  id: "Stopped: Calque 1"
}, /*#__PURE__*/React.createElement("title", null, "Calque 1"), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Graphic_4"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 59.2502,
  cy: 25.4,
  r: 25.4000405867082,
  fill: "#293032"
})), /*#__PURE__*/React.createElement("g", {
  id: "Graphic_3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 101.0502 75.5 C 97.2502 70.6 92.8502 66.1 88.1502 62.1 C 85.8502 60.1 82.8502 59 79.7502 59.1 C 77.2502 59.1 74.7502 59.1 72.3502 59.1 C 72.0502 59.1 71.7502 59.2 71.4502 59.2 L 48.9502 59.2 C 48.7502 59.2 48.6502 59.2 48.4502 59.2 C 45.9502 59.2 43.4502 59.2 41.0502 59.2 C 38.0502 59.1 35.0502 60.2 32.6502 62.2 C 27.9502 66.2 23.5502 70.7 19.7502 75.6 C 2.550199 97.7 -.449801 122.9 .05019902 140.2 C .25019902 147.1 5.850199 152.5 12.650199 152.5 C 12.750199 152.5 12.850199 152.5 13.050199 152.5 C 20.0502 152.3 25.5502 146.5 25.3502 139.5 C 25.0502 129.9 26.2502 117 31.8502 104.5 C 32.3502 120.2 31.8502 136 30.5502 151.5 L 29.8502 159.9 C 29.8502 160.1 29.8502 160.3 29.8502 160.4 C 29.8502 160.6 29.7502 160.8 29.7502 161 C 29.7502 161.3 29.8502 161.5 29.8502 161.8 C 29.8502 162 29.8502 162.1 29.8502 162.3 L 29.6502 203.4 L 29.6502 241.4 C 29.6502 248.4 35.3502 254 42.2502 254 C 49.2502 254 54.8502 248.3 54.8502 241.4 L 54.8502 203.4 L 54.9502 173.6 L 65.7502 173.6 L 65.8502 241.4 C 65.8502 248.4 71.5502 254 78.4502 254 C 85.3502 254 91.0502 248.3 91.0502 241.4 L 91.0502 203.2 L 90.8502 161.8 C 90.8502 161.5 90.9502 161.2 90.9502 160.9 C 90.9502 160.4 90.8502 160 90.8502 159.5 L 89.6502 131.8 C 89.2502 123.2 89.1502 114.3 89.3502 105.3 C 94.5502 117.5 95.6502 129.9 95.3502 139.3 C 95.1502 146.3 100.6502 152.1 107.6502 152.3 C 107.7502 152.3 107.8502 152.3 108.0502 152.3 C 114.8502 152.3 120.4502 146.9 120.6502 140 C 121.2502 122.8 118.2502 97.6 101.0502 75.5 Z",
  fill: "#293032"
})))));

var SvgStopped = function SvgStopped(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 125.72 259",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStopped, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stopped.1e41f728.svg";
export { ForwardRef as ReactComponent };